<template>
	<headerSearch></headerSearch>
	<div class="w1440 personal_center">
		<div class="fs14 flex-box col90 ptb10 page_location">
			当前位置：
			<router-link class="col04" to="/BaseInfo">
				用户中心
				<span class="plr5">/</span>
			</router-link>
			<div class="now_page">我的订单</div>
		</div>
		<div class="flex-box flex-col-start">
			<personal-nav :firstIndex="1" :secondIndex="-1"></personal-nav>
			<div class="ml10 flex-grow-1 part_r">
				<div class="flex-box flex-between mb30 plr40">
					<div class="fs18 col04 fwb">订单列表</div>
					<div class="input_box flex-box">
						<input v-model="query.keyword" confirm-type="search" v-on:keyup.enter="searchOrder" type="text" class="flex-grow-1 fs14" placeholder="可搜索商品名称或订单号" />
						<div class="cursor search_btn fs14" @click="searchOrder">搜索</div>
					</div>
				</div>
				<!-- <div class="num_box flex-box">
                    <div class="num_item flex-grow-1">
                        <div class="col90 fs20">待支付</div>
                        <div class="col12 fs36 fwb">1</div>
                    </div>
                    <div class="num_item flex-grow-1">
                        <div class="col90 fs20">待收货</div>
                        <div class="col12 fs36 fwb">1</div>
                    </div>
                    <div class="num_item flex-grow-1">
                        <div class="col90 fs20">待上传试用报告</div>
                        <div class="col12 fs36 fwb">1</div>
                    </div>
                </div> -->
				<div class="flex-box fs16 mt30 mb30 plr44">
					<div class="col90 mr30">订单类型：</div>
					<!-- <div class="type"><span>全部</span></div> -->
					<div :class="query.order_type == 'general' ? 'active' : ''" @click="onActivityChange('general')" class="type">
						<span>商城订单</span>
					</div>
					<div :class="query.order_type == 'activity' ? 'active' : ''" @click="onActivityChange('activity')" class="type">
						<span>活动订单</span>
					</div>
				</div>
				<div class="flex-box fs16 mb25 plr44" v-if="query.order_type == 'activity'">
					<div class="col90 mr30">活动类型：</div>
					<div class="type" :class="!activityType ? 'active' : ''" @click="onShift('')"><span>全部</span></div>
					<div v-for="(item, index) in searchData.activity" :key="index" @click="onShift(item.value)" :class="activityType == item.value ? 'active' : ''" class="type">
						<span>{{ item.name }}</span>
					</div>
				</div>
				<div class="condition_box pb25">
					<div class="flex-box order_status fs14 col04 plr44">
						<div v-for="(item, index) in tab" :key="index" @click="chooseNav(item.id)" :class="item.id == query.type ? 'active' : ''" class="item">
							{{ item.name }}
							<span class="hint-num" v-if="item.count > 0">{{ item.count }}</span>
						</div>
						<div @click="filter = !filter" class="sort flex-box flex-center colf fs14 cursor" :class="filter ? 'on' : ''">筛选</div>
					</div>
					<template v-if="filter">
						<div class="flex-box fs14 plr44 mt30">
							<div class="col90 mr90">订单时间</div>
							<div class="select_box relative">
								<div class="flex-box select cursor" @click="(showStart = !showStart), (showEnd = false)">
									<div v-if="date_text" class="flex-grow-1">{{ date_text }}</div>
									<div v-else class="flex-grow-1 col90">请选择</div>
								</div>
								<div class="data_list" :class="showStart ? 'show' : ''" style="z-index: 9999">
									<div class="item cursor" @click="dateChange(-1)" :class="!dates.start ? 'active' : ''">全部</div>
									<div class="item cursor" v-for="(item, index) in searchData.dates" :key="index" @click="dateChange(index)" :class="dates.start == item.start ? 'active' : ''">{{ item.name }}</div>
								</div>
							</div>
							<div class="date_picker">
								<input class="input_time" v-model="startTime" type="date" @click="openDatePicker" />
								<div :class="startTime == '' ? 'col7a' : ''">{{ startTime == "" ? "自定最早时间" : startTime }}</div>
							</div>
							<div class="line"></div>
							<div class="date_picker">
								<input class="input_time" v-model="endTime" type="date" @click="openDatePicker" />
								<div :class="endTime == '' ? 'col7a' : ''">{{ endTime == "" ? "自定最终时间" : endTime }}</div>
							</div>
						</div>
						<div class="flex-box fs14 mt20 mb20 plr44 h40">
							<div class="col90 mr90">价格排序</div>
							<div class="type" @click="onSearchFirstTab(2)" :class="!query.order || query.sort != 'pay_fee' ? 'active' : ''"><span>全部</span></div>
							<div class="type" @click="onSearchFirstTab(2, 'desc')" :class="query.order == 'desc' && query.sort == 'pay_fee' ? 'active' : ''"><span>由高到低</span></div>
							<div class="type" @click="onSearchFirstTab(2, 'asc')" :class="query.order == 'asc' && query.sort == 'pay_fee' ? 'active' : ''"><span>由低到高</span></div>
						</div>
						<div class="flex-box fs14 pl152">
							<input class="date_picker fs14" :class="searchList.prices.minprice == '' ? 'col7a' : ''" v-model="searchList.prices.minprice" placeholder="自定最低价格" type="number" v-on:keyup.enter="searchOrder" />
							<div class="line"></div>
							<input class="date_picker fs14" :class="searchList.prices.maxprice == '' ? 'col7a' : ''" v-model="searchList.prices.maxprice" placeholder="自定最高价格" type="number" v-on:keyup.enter="searchOrder" />
						</div>
						<div class="flex-box fs14 mt20 plr44 h40">
							<div class="col90 mr90">时间排序</div>
							<div class="type" @click="onSearchFirstTab(1)" :class="!query.order || query.sort != 'createtime' ? 'active' : ''"><span>全部</span></div>
							<div class="type" @click="onSearchFirstTab(1, 'desc')" :class="query.order == 'desc' && query.sort == 'createtime' ? 'active' : ''"><span>由近及远</span></div>
							<div class="type" @click="onSearchFirstTab(1, 'asc')" :class="query.order == 'asc' && query.sort == 'createtime' ? 'active' : ''"><span>由远及近</span></div>
							<!-- <div class="go shai fs20">去筛选</div> -->
						</div>
						<div class="flex-box flex-col-start flex-wrap fs14 colf plr44 mt30" v-if="(query.order == 'desc' && query.sort == 'createtime') || (query.order == 'asc' && query.sort == 'createtime') || (searchList.prices.minprice && searchList.prices.maxprice)">
							<div v-if="query.order == 'desc' && query.sort == 'createtime'" @click="onSearchFirstTab(1)" class="con_item mr25 flex-box cursor">
								时间：
								<span class="fwb">由近及远</span>
							</div>
							<div v-if="query.order == 'asc' && query.sort == 'createtime'" @click="onSearchFirstTab(1)" class="con_item mr25 flex-box cursor">
								时间：
								<span class="fwb">由远及近</span>
							</div>
							<div v-if="searchList.prices.minprice && searchList.prices.maxprice" @click="delPrices" class="con_item mr25 flex-box con_item mr25 flex-box">
								价格：
								<span class="fwb">{{ searchList.prices.minprice }} ~ {{ searchList.prices.maxprice }}</span>
							</div>
						</div>
					</template>
				</div>
				<div class="mt10">
					<div class="plr44">
						<div class="title_box flex-box fs14 col04">
							<div class="box1 pl30">商品信息</div>
							<div class="box2 tc">金额</div>
							<div class="box3 tc">状态</div>
							<div class="flex-grow-1 tc">操作</div>
						</div>
						<template v-if="query.type == 'aftersale'">
							<div class="box" v-for="(order, index) in orderList" :key="index" @click="onRefundDetail(order.id)">
								<div class="flex-box flex-between title fs14 col12">
									<div class="">售后编号：{{ order.aftersale_sn }}</div>
									<div>{{ formatDate(order.createtime) }}</div>
								</div>
								<div class="order_box flex-box fs14">
									<div>
										<div class="box1 flex-box">
											<img :src="order.goods_image" class="pic" alt="" />
											<div class="flex-grow-1">
												<div class="fs14 col04 m-ellipsis-l2 mb20">{{ order.goods_title }}</div>
												<!-- <div class="fs12 coleb countdown">12 小时 25 分钟后取消</div> -->
												<div class="fs14 col96">×{{ order.goods_num }}</div>
											</div>
										</div>
									</div>
									<div class="box2 tc fs14 coleb fwb">¥ {{ order.aftersale_fee }}</div>
									<div class="box3 tc fs14 col12 fwb">
										<!-- <div>拼单成功</div> -->
										<div :class="order.aftersale_status_text == '待上传试用报告' ? 'wait' : ''">{{ order.aftersale_status_text }}</div>
									</div>
									<div class="flex-grow-1 tc">
										<div class="go cursor detail col04">查看详情</div>
										<div class="go cursor colf" v-if="order.aftersale_status == 0 || order.aftersale_status == 1" @click.stop="onApply(index, order.id)">撤销申请</div>
									</div>
								</div>
							</div>
						</template>
						<template v-else>
							<div class="box" v-for="(order, index) in orderList" :key="index" @click="onOrderDetail(order.order_sn)">
								<div class="flex-box title fs14">
									<div v-if="order.activity_type !== 'groupon' && order.activity_type !== 'new_sample' && order.status == 'unpaid' && !order.pay_cert_status" @click.stop="duigongChick(index)" class="pr15">
										<img v-if="order.checked" src="../../../assets/static/icon/jj_radio_sc.png" class="ico20 cursor" alt="" />
										<img v-else src="../../../assets/static/icon/jxr_circle.png" class="ico20 cursor" alt="" />
									</div>
									<div class="flex-grow-1 col12">订单编号：{{ order.order_sn }}</div>
									<div>{{ order.createtime_text }}</div>
								</div>
								<div class="order_box flex-box fs14">
									<div>
										<div v-for="item in order.items" :key="item.id" class="box1 flex-box">
											<img :src="item.goods_image" class="pic" alt="" />
											<div class="flex-grow-1">
												<div class="fs14 col04 m-ellipsis-l2 mb20">
													<template v-if="order.activity_tag">{{ order.activity_tag }} |</template>
													{{ item.goods_title }}
												</div>
												<div class="fs14 col96">¥ {{ item.goods_price }}×{{ item.goods_num }}</div>
												<!-- <div v-if="order.btns.includes('pay')" class="fs12 coleb countdown">{{ order.ext.countdown_text }}
                        </div> -->
											</div>
										</div>
									</div>
									<div class="box2 tc coleb">¥ {{ order.pay_fee }}</div>
									<div class="box3 tc">
										<!-- <div v-if="order.status_code !== 'closed'">{{ order.status_desc }}</div> -->
										<div :class="order.check_status_text == '待上传试用报告' || order.status_text == '待上传试用报告' ? 'wait' : ''">{{ order.status_code == "nosend" && (order.check_status == "checked" || order.check_status == "failed") ? order.check_status_text : order.status_text }}</div>
									</div>
									<div class="flex-grow-1 tc">
										<div v-if="order.btns.includes('pay')" @click.stop="openPopup(index)" class="go cursor colf">立即付款</div>
										<div v-if="order.btns.includes('cancel')" @click.stop="toggleCancel(order.id)" class="cursor underline col04">取消订单</div>
										<div v-if="order.btns.includes('express')" @click.stop="onExpress(order.order_sn)" class="go cursor colf">查看物流</div>
										<div v-if="order.btns.includes('confirm')" @click.stop="onConfirm(order)" class="go cursor colf">确认收货</div>
										<!-- <div  class="cursor underline col04">修改地址</div> -->
										<div v-if="(order.activity_type != 'groupon' || order.items[0].ladder_status == 0) && (order.btns.includes('apply_refund') || order.btns.includes('re_apply_refund'))" @click.stop="onRefund(order.id, order.items, order.status_code)" class="cursor underline col04">
											{{ order.status_code == "nosend" ? "申请退款" : "退款/退货" }}
										</div>
									</div>
								</div>
								<div v-if="order.btns.includes('pay')" class="fs14 coleb countdown tips">{{ order.ext.countdown_text }}</div>
							</div>
						</template>
						<div v-if="orderList.length == 0" class="nodata fs16 tc">
							<img src="../../../assets/static/icon/c_notitle.png" class="c_nodata" alt="" />
							<div>暂无相关数据</div>
						</div>
					</div>
					<template v-if="orderList.length > 0">
						<div class="flex flex-box total_pay plr44 fs16 col9" v-if="query.type == 'all' || query.type == 'unpaid'">
							<div class="flex-box cursor" @click.stop="allCheckedClick()">
								<img v-if="allCheckedStatus" src="../../../assets/static/icon/jj_radio_sc.png" class="ico20 cursor" alt="" />
								<img v-else src="../../../assets/static/icon/jxr_circle.png" class="ico20 cursor" alt="" />
								<div class="ml10">全选</div>
							</div>
							<div class="flex-grow-1 ml20">已选：{{ checkedCount }}</div>
							<div class="btn22 fs14 colf tc cursor" @click="openMultiPopup()">合并支付</div>
						</div>
					</template>
					<pagination :sumCount="sumCount" :perCount="perCount" @pageTurn="pickpage" v-show="sumCount > perCount"></pagination>
				</div>
			</div>
		</div>
	</div>
	<popup :visible="cancelPop" @close="cancelPop = false">
		<div class="cancel_pop">
			<div class="content">
				<img src="../../../assets/static/icon/c_order_close.png" class="order_close" alt="" @click="cancelPop = false" />
				<div class="fs24 col3 fwb tc">订单取消</div>
				<div class="pl10">
					<div class="tips fs16 coleb flex-box">取消后无法恢复，请谨慎选择。</div>
					<div class="fs18 colb mb30">请选择取消订单原因</div>
					<div v-for="(item, index) in cancelReasonList" :key="index" @click="onChange(index)" class="flex-box reason fs20 col3" :class="reasonIndex == index ? 'active' : ''">{{ item.content }}</div>
				</div>
				<div class="flex-box flex-between btn_box fs20 fwb">
					<div class="btn1 col3d" @click="cancelConfirm()">确定取消</div>
					<div class="btn2 colf" @click="cancelPop = false">暂不取消</div>
				</div>
			</div>
		</div>
	</popup>
	<popup :visible="newAddPop" @close="newAddPop = false">
		<div class="add_pop relative bgf br10">
			<div class="title_box">
				<img src="../../../assets/static/icon/c_pop_close.png" class="pop_close cursor" @click="newAddPop = false" alt="" />
				<div class="title fs24 fwb col12 flex-box">
					修改收货人信息
					<i class="add"></i>
				</div>
				<div class="fs16 coleb tips flex-box flex-col-start">因订单已分配，仅支持修改部分信息，且可能影响送货时间，提交后可在订单详情页查看结果。</div>
			</div>
			<div class="form_box">
				<div class="flex-box mb25">
					<div class="mr102">
						<div class="title must fs18 col04 relative mb15">姓名</div>
						<input type="text" class="input fs16" placeholder="请输入联系人" />
					</div>
					<div>
						<div class="title must fs18 col04 relative mb15">手机号</div>
						<input type="text" class="input fs16" placeholder="请输入联系手机号" />
					</div>
				</div>
				<div class="title fs18 col04 relative mb15">邮政编码</div>
				<input type="text" class="input fs16 code mb25" placeholder="请输入您的邮编" />
				<div class="title must fs18 col04 relative mb15">地址信息</div>
				<div class="flex-box mb15">
					<div class="select_box relative mr20">
						<div class="flex-box flex-center select fs16 cursor" @click="(showProvince = !showProvince), (showCity = showArea = false)">
							<div class="col90 pr10">所属省份</div>
						</div>
						<div class="data_list" :class="showProvince ? 'show' : ''">
							<div class="item fs16 cursor" v-for="(item, index) in 30" :key="index">省份1</div>
						</div>
					</div>
					<div class="select_box relative mr20">
						<div class="flex-box flex-center select fs16 cursor" @click="(showCity = !showCity), (showProvince = showArea = false)">
							<div class="col90 pr10">所属城市</div>
						</div>
						<div class="data_list" :class="showCity ? 'show' : ''">
							<div class="item fs16 cursor" v-for="(item, index) in 30" :key="index">省份1</div>
						</div>
					</div>
					<div class="select_box relative">
						<div class="flex-box flex-center select fs16 cursor" @click="(showArea = !showArea), (showCity = showProvince = false)">
							<div class="col90 pr10">所属区域</div>
						</div>
						<div class="data_list" :class="showArea ? 'show' : ''">
							<div class="item fs16 cursor" v-for="(item, index) in 30" :key="index">省份1</div>
						</div>
					</div>
				</div>
				<textarea class="textarea fs16 mb25" placeholder="请输入您的详细地址，具体到**室**号"></textarea>
				<div class="flex-box flex-between cursor" @click="setDefault = !setDefault">
					<div class="fs18 col04">设为默认地址</div>
					<i class="default" :class="setDefault ? 'active' : ''"></i>
				</div>
				<div class="cursor sure fs18 colf">修 改</div>
			</div>
		</div>
	</popup>
	<popup :visible="refusePop" @close="refusePop = false">
		<div class="refuse_pop">
			<div class="content">
				<img src="../../../assets/static/icon/c_order_close.png" class="order_close" alt="" @click="refusePop = false" />
				<div class="pic_box">
					<img src="../../../assets/static/images/invoice.png" class="pic" alt="" />
					<div class="status_box flex-box flex-center">
						<img src="../../../assets/static/icon/c_order_status1.png" class="c_order_status1" v-if="refuse_status == 1" alt="" />
						<img src="../../../assets/static/icon/c_order_status2.png" class="c_order_status2" v-if="refuse_status == 2" alt="" />
					</div>
				</div>
				<div class="flex-box flex-center fs30 coleb fwb tips" v-if="refuse_status == 1">您的取消订单申请已驳回</div>
				<div class="flex-box flex-center fs30 col3d fwb tips" v-if="refuse_status == 2">待平台审核</div>
				<div class="fs24 col90 tc mt30">
					<div class="rea">{{ refuse_status == 1 ? "驳回原因" : "" }}</div>
					<div v-if="refuse_status == 1">圣诞节艾迪康纳斯卡打开的吗理科生的都没啥</div>
					<div v-if="refuse_status == 2">您的订单取消申请已提交，请耐心等待平台审核</div>
				</div>
			</div>
		</div>
	</popup>
	<popup :visible="refundPop" @close="refundPop = false">
		<div class="refund_pop">
			<div class="content">
				<img src="../../../assets/static/icon/c_order_close.png" class="order_close" alt="" />
				<div class="fs22 col04 fwb tc">退款/退货</div>
				<div class="fs18 colb mb30 mt15">请选择取消订单原因</div>
				<div class="flex-box reason fs20 col3 active">仅退款</div>
				<div class="flex-box reason fs20 col3">退款/退货</div>
				<div class="flex-box flex-between btn_box fs20 fwb">
					<div class="btn1 col3d">取消</div>
					<div class="btn2 colf" @click="cancelPop = false">确认</div>
				</div>
			</div>
		</div>
	</popup>
	<popup :visible="orderPopStatus" @close="orderPopStatus = false">
		<div class="pop2 p20">
			<div class="fs20 tc title fwb">支付方式</div>
			<div @click="changeOrderPayment(index)" class="flex flex-box mt25" v-for="(pay, index) in payTypeList2" :key="index">
				<img :src="pay.icon" class="ico20 cursor" alt="" />
				<div class="flex-grow-1 fs18 ml10">
					{{ pay.name }}
				</div>
				<img @click="onActivityCheck" v-if="payIndex2 == index" src="../../../assets/static/icon/jj_radio_sc.png" class="ico20 cursor" alt="" />
				<img @click="onActivityCheck" v-else src="../../../assets/static/icon/jj_radio_uc.png" class="ico20 cursor" alt="" />
			</div>
			<div class="btn_confirm2 fs16 colf tc mt20 cursor" @click="onOrderPay()">确认付款</div>
		</div>
	</popup>
</template>

<script>
	import PersonalNav from "../../../components/PersonalNav.vue";
	import { useHead } from "@unhead/vue";
	import { onMounted } from "vue";
	import moment from "moment";
	export default {
		setup() {
			onMounted(() => {
				useHead({
					title: "我的订单-小狮优选",
					meta: [
						{ name: "description", content: "This is my page description" },
						{ property: "og:title", content: "My Page Title" },
						{ property: "og:description", content: "This is my page description" },
						{ property: "og:url", content: "https://example.com/my-page" },
						{ property: "og:image", content: "https://example.com/my-image.jpg" },
					],
					link: [{ rel: "canonical", href: "https://example.com/my-page" }],
				});
			});
		},
		components: {
			PersonalNav,
		},
		data() {
			const date = new Date();
			const years = [];
			const year = date.getFullYear();
			const months = [];
			const month = date.getMonth() + 1;
			const days = [];
			const day = date.getDate();
			for (let i = 1990; i <= date.getFullYear(); i++) {
				years.push(i);
			}
			for (let i = 1; i <= 12; i++) {
				months.push(i);
			}
			for (let i = 1; i <= 31; i++) {
				days.push(i);
			}
			return {
				cancelReasonList: [
					{
						id: 1,
						content: "不想要了",
					},
					//{id:2,content:"拍错地址"},
					{
						id: 3,
						content: "拍错产品",
					},
				],
				reasonIndex: 0,
				reasonType: 1,
				showStart: false,
				tab: [
					{
						id: "all",
						name: "全部订单",
					},
					{
						id: "unpaid",
						name: "待付款",
						count: 0,
					},
					{
						id: "nosend",
						name: "待发货",
						count: 0,
					},
					{
						id: "noget",
						name: "待收货",
						count: 0,
					},
					{
						id: "completed",
						name: "已完成",
					},
					{
						id: "aftersale",
						name: "取消/售后",
						count: 0,
					},
				],
				filter: false,
				sumCount: 0,
				perCount: 10,
				startTime: "",
				endTime: "",
				startPrice: "",
				cancelPop: false,
				newAddPop: false,
				refusePop: false,
				refundPop: false,
				refuse_status: 2,

				years,
				months,
				days,
				value: [9999, month - 1, day - 1],
				indicatorStyle: `height: 33px;border-radius: 20rpx;background:transparent;color:#fff;`,

				show: false,
				statusBarHeight: null,
				barHeight: null,

				showmore: false, //更多
				moreindex: null,
				showOrder: false, //订单取消弹窗
				reasonIndex: 0,
				showOverrule: false, //驳回弹窗
				showAudit: false, //待平台审核弹窗
				showReturns: false, //退款/退货弹窗

				searchData: {
					dates: [],
					activity: [],
				}, //搜索条件
				searchFirstIndex: -1,
				todayDate: year + "-" + (month < 10 ? "0" + month : month) + "-" + day,
				dates: {
					start: "",
					end: "",
					change_end: year + "-" + (month < 10 ? "0" + month : month) + "-" + day,
				}, //中间值
				date_text: "",
				activityType: null,
				minprice: "",
				maxprice: "",
				searchList: {
					dates: null,
					prices: {
						minprice: "",
						maxprice: "",
					},
					activity_type: null,
				}, //搜索条件
				query: {
					order_type: "general",
					activity_type: "",
					keyword: "",
					type: "all",
					list_rows: 10,
					page: 1,
				},
				checkedCount: 0,
				orderList: [],
				orderMore: {
					page: 1,
				},
				orderId: 0, //点击选中的订单号
				searchPopStatus: false, //搜索弹窗
				cancelPopStatus: false, //取消弹窗
				timeData: [],
				type: "",
				block: false,
				payIndex2: 0,
				payTypeList2: [
					{ id: "wechat", name: "微信支付", icon: require("../../../assets/static/images/jxr_pay_icon3.png") },
					{ id: "duigong", name: "公对公付款", icon: require("../../../assets/static/images/jxr_pay_icon2.png") },
				],
				orderPopStatus: false,
				chooseOrder: null,
				payMulti: false,

				allCheckedStatus: false,
			};
		},
		computed: {
			islogin() {
				return this.$h.islogin();
			},
		},
		watch: {
			startTime(newVal, oldVal) {
				if (!this.block) {
					this.mixRefresh();
				}
			},
			endTime(newVal, oldVal) {
				if (!this.block) {
					this.mixRefresh();
				}
			},
		},
		created() {
			if (!this.islogin) {
				this.$router.push("/Login");
			} else {
				// 在 mounted 钩子中访问路由参数
				this.type = this.$route.query.type || "all";
				this.fetchOrderNum();
				this.chooseNav(this.type);
				this.$api.getOrderSearch().then((res) => {
					this.searchData = res.data;
				});
			}
		},
		methods: {
			//格式化日期
			formatDate(timestamp) {
				if (!timestamp) {
					return "";
				}
				return moment(timestamp * 1000).format("YYYY-MM-DD HH:mm:ss");
			},
			fetchOrderNum() {
				let tab = this.tab;
				this.$api.OrderCount({ activity_type: this.query.order_type }).then((ret) => {
					for (let i = 0; i < tab.length; i++) {
						tab[i].count = ret.data[tab[i].id] || 0;
					}
					this.tab = tab;
				});
			},
			//批量对公选择
			duigongChick(index) {
				this.orderList[index].checked = !this.orderList[index].checked;
				let total = 0;
				this.orderList.forEach((order) => {
					if (order.checked) {
						total += 1;
					}
				});
				this.checkedCount = total;
				this.$forceUpdate();
			},
			allCheckedClick() {
				this.allCheckedStatus = !this.allCheckedStatus;
				let total = 0;
				for (let i = 0; i < this.orderList.length; i++) {
					let order = this.orderList[i];
					if (order.activity_type !== "groupon" && order.activity_type !== "new_sample" && order.status == "unpaid" && !order.pay_cert_status) {
						this.orderList[i]["checked"] = this.allCheckedStatus;
						if (this.allCheckedStatus) {
							total += 1;
						}
					}
				}
				this.checkedCount = total;
				this.$forceUpdate();
			},
			//单个订单立即支付
			openPopup(index) {
				this.chooseOrder = this.orderList[index];
				this.payMulti = false;
				this.orderPopStatus = true;
			},
			//多个订单立即支付
			openMultiPopup(index) {
				let orderSn = [];
				this.orderList.forEach((order) => {
					if (order.checked) {
						orderSn.push(order.order_sn);
					}
				});
				if (orderSn.length <= 0) {
					this.$message.error("请选择待付款订单");
					return;
				}
				this.payMulti = true;
				this.orderPopStatus = true;
			},
			changeOrderPayment(index) {
				this.payIndex2 = index;
			},
			onOrderPay() {
				let payment = this.payTypeList2[this.payIndex2].id;
				let orderSn = [];
				if (!this.payMulti) {
					let order_sn = this.chooseOrder.order_sn;
					orderSn.push(order_sn);
				} else {
					this.orderList.forEach((order) => {
						if (order.checked) {
							orderSn.push(order.order_sn);
						}
					});
				}
				if (orderSn.length <= 0) {
					uni.showToast({
						title: "请选择待付款订单",
						icon: "error",
					});
					return;
				}
				let data = JSON.stringify({
					orderSN: orderSn.join(","),
					payment: payment,
					payState: "paying",
					orderType: "goods",
					//buyType: this.orderPayload.buy_type || ''
				});
				if (payment == "wechat") {
					//微信扫码支付
					this.$router.push({ path: "/Checkout", query: { data: encodeURIComponent(data) } });
				} else {
					//对公支付
					this.$router.push({ path: "/Corporate", query: { data: encodeURIComponent(data) } });
				}
				this.orderPopStatus = false;
			},
			cancelConfirm() {
				let reason = this.cancelReasonList[this.reasonIndex].content;
				this.onCancel({
					reason,
				});
			},
			async onCancel(e) {
				let orderId = this.orderId;
				this.$api
					.OrderCacncel({
						id: orderId,
						reason: e.reason,
					})
					.then((ret) => {
						this.cancelPop = false;
						this.$message({
							customClass: "custom-message",
							message: "取消成功",
							type: "success",
						});
						let index = this.orderList.findIndex((order) => order.id === orderId);
						this.orderList[index] = ret.data;
						this.$forceUpdate();
					});
			},
			onChange(index) {
				this.reasonIndex = index;
				this.reasonType = this.cancelReasonList[index].id;
			},
			//取消订单
			toggleCancel(orderId) {
				this.orderId = orderId;
				this.cancelPop = true;
			},
			delPrices() {
				this.searchList.prices = {
					minprice: "",
					maxprice: "",
				};
				this.mixRefresh();
			},
			//搜索Tab
			onSearchFirstTab(index, order = "") {
				this.searchFirstIndex = index;
				if (this.searchFirstIndex == 1 || this.searchFirstIndex == 2) {
					// this.toggleSearchPop({
					//   searchPopStatus: false
					// })
					if (this.searchFirstIndex == 1) {
						this.query.sort = order ? "createtime" : "";
						this.query.order = order;
					} else {
						this.query.sort = order ? "pay_fee" : "";
						this.query.order = order;
					}
					if (!this.query.sort && !this.query.order) {
						delete this.query.sort;
						delete this.query.order;
					}
					this.mixRefresh();
				} else if (this.searchFirstIndex == 0) {
					this.toggleSearchPop({
						searchPopStatus: true,
					});
				} else if (this.searchFirstIndex == 3) {
					this.toggleSearchPop({
						searchPopStatus: true,
					});
				}
			},
			//自定义时间-中间值
			dateChange(index) {
				this.block = true;
				setTimeout(() => {
					this.block = false;
				}, 1000);
				if (index >= 0) {
					let dates = this.searchData.dates;
					this.dates.start = dates[index].start;
					this.dates.end = dates[index].end;
					this.dates.change_end = ""; //change日期置空;
					this.date_text = this.searchData.dates[index].name;
				} else {
					this.dates.change_end = this.todayDate; //change日期初始化;
					this.dates.start = "";
					this.dates.end = "";
					this.date_text = "";
				}
				this.startTime = this.dates.start;
				this.endTime = this.dates.end;
				this.showStart = false;
				this.mixRefresh();
			},
			//自定义日期
			bindChange: function (e) {
				this.value = e.detail.value;
				const val = e.detail.value;
				this.dates.change_end = this.years[val[0]] + "-" + this.months[val[1]] + "-" + this.days[val[2]];
				//tab日期置空
				this.dates.start = "";
				this.dates.end = "";
			},
			//筛选-活动类型
			onShift(activityType) {
				this.activityType = activityType == this.activityType ? null : activityType;
				this.mixRefresh();
			},
			pickpage(e) {
				console.log("pickpage", e + 1);
				this.orderList = [];
				this.orderMore = {
					page: 1,
				};
				this.query.page = e + 1;
				this.mixRefresh();
			},
			mixRefresh() {
				if (this.query.type == "aftersale") {
					this.refreshAftersale();
				} else {
					this.refresh();
				}
			},
			//普通订单-活动订单切换
			onActivityChange(orderType) {
				this.query.order_type = orderType;
				this.activityType = "";
				this.fetchOrderNum();
				if (this.query.type == "aftersale") {
					this.refreshAftersale();
				} else {
					this.refresh();
				}
			},
			//切换状态
			chooseNav(type) {
				if (type == "aftersale") {
					this.query.type = type;
					this.refreshAftersale();
				} else {
					this.query.type = type;
					this.refresh();
				}
			},
			//刷新列表
			refresh() {
				this.orderList = [];
				this.orderMore = {
					page: 1,
				};
				this.fetch();
			},
			fetch() {
				let query = this.query;
				let searchList = this.searchList;
				if (searchList.dates) {
					if (searchList.dates.change_end) {
						query.start = "";
						query.end = "";
						query.change_end = searchList.dates.change_end;
					} else {
						query.change_end = "";
						query.start = searchList.dates.start;
						query.end = searchList.dates.end;
					}
				} else {
					query.change_end = "";
					query.start = "";
					query.end = "";
				}
				if (this.startTime) {
					query.start = this.startTime;
				}
				if (this.endTime) {
					query.end = this.endTime;
				}
				if (searchList.prices) {
					query.minprice = searchList.prices.minprice;
					query.maxprice = searchList.prices.maxprice;
				} else {
					query.minprice = "";
					query.maxprice = "";
				}
				query.activity_type = searchList.activity_type ? searchList.activity_type : "";
				if (this.activityType) {
					query.activity_type = this.activityType;
				}
				let that = this;
				this.$api.getOrder(query).then((res) => {
					that.orderList = res.data.data;
					if (that.orderList.length > 0) {
						that.orderList.map((n) => {
							if (n.btns.includes("pay") && n.ext.expired_in >= 0) {
								n.ext.countdown_text = that.$h.timeFormat(n.ext.expired_in);
								n.ext.it = setInterval(() => {
									n.ext.expired_in--;
									n.ext.countdown_text = that.$h.timeFormat(n.ext.expired_in);
									if (n.ext.expired_in <= 0) {
										clearInterval(n.ext.it);
										// that.chooseNav(that.type);
									}
								}, 1000);
							}
						});
					}
					that.allCheckedStatus = false;
					that.checkedCount = 0;
					that.sumCount = res.data.total;
					that.perCount = res.data.per_page;
				});
			},

			//关键词搜索
			searchOrder() {
				if (this.query.type == "aftersale") {
					this.refreshAftersale();
				} else {
					this.refresh();
				}
			},
			openDatePicker(event) {
				// 触发日期选择器
				event.target.showPicker();
			},
			refreshAftersale() {
				this.orderList = [];
				this.orderMore = {
					page: 1,
				};
				this.fetchAftersale();
			},
			fetchAftersale() {
				let query = this.query;
				let searchList = this.searchList;
				if (searchList.dates) {
					if (searchList.dates.change_end) {
						query.start = "";
						query.end = "";
						query.change_end = searchList.dates.change_end;
					} else {
						query.change_end = "";
						query.start = searchList.dates.start;
						query.end = searchList.dates.end;
					}
				} else {
					query.change_end = "";
					query.start = "";
					query.end = "";
				}
				if (searchList.prices) {
					query.minprice = searchList.prices.minprice;
					query.maxprice = searchList.prices.maxprice;
				} else {
					query.minprice = "";
					query.maxprice = "";
				}
				query.activity_type = searchList.activity_type ? searchList.activity_type : "";

				this.$api.getAfterSale(query).then((res) => {
					this.orderList = res.data.data;
					this.sumCount = res.data.total;
					this.perCount = res.data.per_page;
				});
			},
			//订单详情
			onOrderDetail(orderSN) {
				// this.$router.push({
				// 	path: "/OrderDetail",
				// 	query: {
				// 		orderSn: orderSN,
				// 	},
				// });
				const targetPath = this.$router.resolve({
					path: "/OrderDetail",
					query: {
						orderSn: orderSN,
					},
				}).href;
				// 在新窗口中打开目标页面
				window.open(targetPath, "_blank");
			},
			//物流
			onExpress(orderId) {
				this.$router.push({ path: "/LogDetail", query: { id: orderId } });
			},
			//批量对公选择
			duigongChick(index) {
				this.orderList[index].checked = !this.orderList[index].checked;
				let total = 0;
				this.orderList.forEach((order) => {
					if (order.checked) {
						total += 1;
					}
				});
				this.checkedCount = total;
				this.$forceUpdate();
			},
			// 确认收货
			async onConfirm(order, ignore = false) {
				// 需开启确认收货组件
				let page = this;
				this.$confirm("确定要收货？", "提示", {
					confirmButtonText: "确定",
					cancelButtonText: "取消",
				}).then(() => {
					page.$api.OrderConfirm({ id: order.id }).then((ret) => {
						let index = page.orderList.findIndex((item) => item.id === order.id);
						page.orderList[index] = ret.data;
						page.$forceUpdate();
					});
				});
			},
			//售后详情
			onRefundDetail(id) {
				// this.$router.push({ path: '/RefundStatus', query: { id: id } })
				const targetPath = this.$router.resolve({ path: "/RefundStatus", query: { id: id } }).href;
				// 在新窗口中打开目标页面
				window.open(targetPath, "_blank");
			},
			onRefund(orderId, items, status_code) {
				let item_ids = [];
				items.forEach((item) => {
					item_ids.push(item.id);
				});
				this.refundData = {
					order_id: orderId,
					item_ids: item_ids.join(","),
					refund_from: "order",
				};
				if (status_code == "nosend") {
					let query = this.refundData;
					query.expressIndex = 0;
					this.$router.push({
						path: "/Refund",
						query: query,
					});
				} else {
					this.refundPop = true;
				}
			},

			onApply(index, orderId) {
				let page = this;
				this.$confirm("确定要取消此申请吗？", "提示", {
					confirmButtonText: "确定",
					cancelButtonText: "取消",
				}).then(() => {
					page.$api.AftersaleCancel({ id: orderId }).then((ret) => {
						page.orderList[index] = ret.data;
					});
				});
			},
		},
	};
</script>

<style lang="less" scoped>
	.pl152 {
		padding-left: 196px;
	}

	.mr102 {
		margin-right: 102px;
	}

	.part_r {
		background: #fff;
		padding-top: 41px;

		.plr44 {
			padding-left: 44px;
			padding-right: 44px;
		}

		.num_box {
			margin: 33px 0 34px;
			line-height: 28px;

			.num_item {
				padding-top: 10px;
				padding-left: 44px;
				padding-bottom: 24px;
				border-right: 1px solid rgba(98, 134, 171, 0.4);

				.col12 {
					margin-top: 33px;
					line-height: 50px;
				}

				&:last-child {
					border: none;
				}
			}
		}

		.input_box {
			width: 468px;
			height: 40px;
			border-radius: 8px;
			border: 2px solid #3d7efe;
			padding-left: 20px;

			&::before {
				content: "";
				display: block;
				background: url("/src/assets/static/icon/c_search.png") no-repeat center;
				background-size: 100%;
				width: 22px;
				height: 22px;
				margin-right: 10px;
			}

			input {
				height: 52px;
			}

			.search_btn {
				width: 80px;
				height: 40px;
				border-radius: 8px;
				background: #1275ff;
				text-align: center;
				line-height: 40px;
				margin: -1px -1px 0 0;
				color: #ffffff;
				font-weight: 400;
				letter-spacing: 4.090909px;
			}
		}

		.type {
			margin-right: 40px;
			color: #040404;

			& span:hover,
			&.active span {
				color: #3d7efe;
				font-weight: bold;
				cursor: pointer;
			}
		}

		.condition_box {
			background: #fbfcfd;
		}

		.order_status {
			height: 50px;
			border-bottom: 1px solid rgba(98, 134, 171, 0.4);

			.item {
				margin-right: 88px;
				line-height: 50px;
				cursor: pointer;
				position: relative;

				&.active,
				&:hover {
					color: #1275ff;
					font-weight: bold;
					font-size: 16px;
					position: relative;

					&::after {
						content: "";
						display: block;
						width: 100%;
						height: 4px;
						background: #1275ff;
						position: absolute;
						bottom: 0;
						left: 0;
						right: 0;
						margin: auto;
					}
				}
			}

			.hint-num {
				min-width: 16px;
				line-height: 16px;
				border-radius: 100px;
				background: red;
				position: absolute;
				top: 10px;
				right: -25px;
				font-size: 12px;
				padding: 0 3px;
				color: #fff;
				font-weight: normal !important;
				text-align: center;
			}

			.sort {
				width: 108px;
				height: 44px;
				background: #1275ff;
				border-radius: 6px;
				font-weight: 500;
				margin-left: auto;

				&::after {
					content: "";
					display: block;
					width: 17px;
					height: 17px;
					background: url("../../../assets/static/icon/c_sort.png") no-repeat center;
					background-size: 100%;
					margin-left: 6px;
				}
				&.on::after {
					background-image: url("../../../assets/static/icon/c_sort-on.png");
				}
			}
		}

		.select_box {
			width: 170px;
			border-radius: 8px;
			border: 1px solid rgba(98, 134, 171, 0.2);
			padding: 0 24px;
			margin-right: 63px;
		}

		.select_box .select {
			height: 38px;
		}

		.select_box .select::after {
			content: "";
			display: block;
			background: url("/src/assets/static/icon/c_arrowd.png") no-repeat center;
			background-size: 100%;
			width: 16px;
			height: 16px;
		}

		.data_list {
			max-height: 300px;
			overflow-y: scroll;
			position: absolute;
			top: 40px;
			left: 0;
			right: 0;
			background-color: #fff;
			border-radius: 0 0 8px 8px;
			display: none;
			border: 1.6px solid rgba(98, 134, 171, 0.2);
		}

		.data_list.show {
			display: block;
		}

		.data_list .item {
			line-height: 40px;
			white-space: nowrap;
			text-overflow: ellipsis;
			overflow: hidden;
			padding: 0 24px;
		}

		.data_list .item:hover {
			background: #1275ff;
			color: #fff;
		}

		.date_picker {
			width: 200px;
			background: rgba(150, 150, 150, 0.06);
			border-radius: 8px;
			position: relative;
			line-height: 40px;
			text-align: center;

			.input_time {
				width: 100%;
				height: 100%;
				opacity: 0;
				position: absolute;
				top: 0;
				left: 0;
				z-index: 2;
				cursor: pointer;
			}
		}

		.line {
			width: 66px;
			height: 2px;
			background: #dedede;
			margin: 0 25px;
		}

		.go {
			width: 102px;
			height: 33px;
			line-height: 33px;
			background: #1275ff;
			border-radius: 6px;
			text-align: center;
			margin: 0 auto;

			&.detail {
				width: 103px;
				height: 33px;
				border-radius: 6px;
				border: 1px solid #979797;
				background: #fff;
			}
		}

		.go ~ .go,
		.go ~ .underline {
			margin-top: 25px;
		}

		.con_item {
			height: 58px;
			background: #3d7efe;
			border-radius: 8px;
			padding: 0 16px 0 23px;

			&::after {
				content: "";
				display: block;
				background: url("../../../assets/static/icon/c_delete.png") no-repeat center;
				background-size: 100%;
				width: 22px;
				height: 22px;
				margin-left: 13px;
			}
		}

		.box {
			border: 1px solid rgba(98, 134, 171, 0.3);
			margin-bottom: 15px;

			.title {
				height: 40px;
				background: #e3efff;
				padding: 0 20px;
			}
		}

		.title_box {
			height: 50px;
			background: #fafcff;
			margin-bottom: 10px;
		}

		.order_box {
			padding: 12px 0;
		}

		.box1 {
			width: 456px;

			.pic {
				width: 100px;
				height: 100px;
				background: #ffffff;
				border-radius: 8px;
				border: 1px solid rgba(98, 134, 171, 0.3);
				margin: 0 12px;
			}

			& ~ .box1 {
				margin-top: 15px;
			}
		}

		.countdown {
			line-height: 48px;
			background: rgba(235, 63, 37, 0.06);
			border-radius: 4px;
			text-align: center;
		}

		.box2 {
			width: 150px;
		}

		.box3 {
			width: 170px;
		}

		// .col04.underline {
		//   margin-top: 23px;
		// }
	}

	.colb {
		color: #bbb;
	}

	.order_close {
		width: 16px;
		height: 16px;
		position: absolute;
		top: 23px;
		right: 27px;
		cursor: pointer;
	}

	.cancel_pop {
		width: 566px;
		border-radius: 24px;
		border: 6px solid rgba(255, 255, 255, 0.4);

		.content {
			height: 100%;
			width: 100%;
			background-color: #fff;
			border-radius: 19px;
			position: relative;
			padding: 64px 30px 61px;

			.tips {
				height: 32px;
				background: rgba(235, 63, 37, 0.06);
				border-radius: 4px;
				margin: 26px 0 22px;

				&::before {
					content: "";
					display: block;
					background: url("../../../assets/static/icon/c_wait.png") no-repeat center;
					background-size: 100%;
					width: 14px;
					height: 14px;
					margin: 0 7px 0 9px;
				}
			}

			.reason {
				margin-bottom: 41px;
				cursor: pointer;

				&::after {
					content: "";
					display: block;
					width: 22px;
					height: 22px;
					background: url("../../../assets/static/icon/c_check2.png") no-repeat center;
					background-size: 100%;
					margin-left: auto;
				}

				&.active::after {
					background-image: url("../../../assets/static/icon/c_check2-on.png");
				}
			}

			.btn_box {
				div {
					width: 245px;
					height: 60px;
					border-radius: 8px;
					border: 1px solid #3d7efe;
					display: flex;
					align-items: center;
					justify-content: center;
					cursor: pointer;
				}

				.btn2 {
					background: #3d7efe;
				}
			}
		}
	}

	.add_pop {
		width: 1088px;

		.title_box {
			height: 180px;
			padding-top: 40px;
		}

		i.add {
			width: 22.5px;
			height: 26px;
			background-image: url("../../../assets/static/icon/c_address.png");
			margin-left: 18px;
		}

		.tips {
			width: 586px;
			padding: 4px 7px 7px 13px;
			background: rgba(235, 63, 37, 0.06);
			border-radius: 5px;
			line-height: 22px;
			margin-top: 17px;

			&::before {
				content: "";
				display: block;
				background: url("../../../assets/static/icon/c_wait.png") no-repeat center;
				background-size: 100%;
				width: 15px;
				height: 15px;
				margin: 4px 8px 0 0;
			}
		}

		.form_box {
			padding-left: 62px;
			padding-right: 62px;

			.input {
				width: 380px;
				height: 66px;
				border-radius: 8px;
			}

			.select_box {
				width: 308px;
				height: 66px;
				border-radius: 8px;

				.select {
					height: 62px;
				}
			}

			.textarea {
				width: 100%;
			}

			.sure {
				width: 134px;
				height: 50px;
				line-height: 50px;
				background: #1275ff;
				border-radius: 8px;
				margin-top: 55px;
			}
		}
	}

	.refuse_pop {
		width: 732px;
		border-radius: 31px;
		padding: 4px;
		background: linear-gradient(180deg, rgba(243, 246, 246, 1), rgba(184, 229, 255, 0.5));

		.content {
			width: 100%;
			height: 100%;
			background: linear-gradient(180deg, rgba(184, 214, 255, 0.2) 0%, rgba(255, 255, 255, 0) 100%), #ffffff;
			border-radius: 27px;
			padding-top: 103px;
			padding-bottom: 74px;

			.pic_box {
				width: 262px;
				height: 262px;
				border-radius: 21px;
				border: 5px solid #e7f1ff;
				overflow: hidden;
				position: relative;
				margin: 0 auto 75px;

				.pic {
					width: 100%;
					height: 100%;
					border: 2px solid #e0e7ee;
					border-radius: 16px;
					position: relative;
					z-index: 1;
					object-fit: cover;
				}

				.status_box {
					width: 100%;
					height: 100%;
					background: rgba(86, 86, 86, 0.2);
					position: absolute;
					top: 0;
					left: 0;
					z-index: 2;
				}
			}

			.tips {
				height: 38px;
				line-height: 38px;

				&::before {
					width: 38px;
					height: 38px;
					display: block;
					content: "";
					background: url("../../../assets/static/icon/c_wait.png") no-repeat center;
					background-size: 100%;
					margin-right: 12px;
				}

				&.col3d::before {
					display: none;
				}
			}

			.rea {
				height: 36px;
			}
		}
	}

	.refund_pop {
		width: 410px;
		border-radius: 31px;
		padding: 4px;
		background: linear-gradient(180deg, rgba(243, 246, 246, 1), rgba(184, 229, 255, 0.5));

		.content {
			width: 100%;
			height: 100%;
			background: linear-gradient(180deg, rgba(184, 214, 255, 0.2) 0%, rgba(255, 255, 255, 0) 100%), #ffffff;
			border-radius: 27px;
			padding: 40px 24px;
			position: relative;

			.reason {
				margin-bottom: 24px;
				cursor: pointer;

				&::after {
					content: "";
					display: block;
					width: 22px;
					height: 22px;
					background: url("../../../assets/static/icon/c_check2.png") no-repeat center;
					background-size: 100%;
					margin-left: auto;
				}

				&.active::after {
					background-image: url("../../../assets/static/icon/c_check2-on.png");
				}
			}

			.btn_box {
				margin-top: 43px;

				div {
					width: 170px;
					height: 60px;
					border-radius: 10px;
					border: 2px solid #d2d2d2;
					line-height: 56px;
					text-align: center;
				}

				.btn2 {
					background: #3d7efe;
					border-color: #3d7efe;
				}
			}
		}
	}

	.pop2 {
		width: 410px;
		border-radius: 10px;
		background: #fff;

		.title {
			width: 100%;
			display: block;
		}

		.pay_icon {
			widows: 20px;
			height: auto;
			display: block;
		}

		.ico20 {
			width: 20px;
			height: auto;
			display: block;
		}

		.btn_confirm2 {
			display: block;
			width: 370px;
			text-align: center;
			height: 50px;
			line-height: 50px;
			background: #3d7efe;
			border-radius: 8px;
		}
	}

	.total_pay {
		position: sticky;
		bottom: 0;
		left: 0;
		right: 0;
		background: #fff;
		height: 65px;
		box-shadow: 0px -2px 8px 0px #dfe5ef;
	}

	.relative {
		position: relative;
	}

	.ico20 {
		width: 20px;
		height: auto;
		display: block;
	}

	.btn22 {
		width: 140px;
		text-align: center;
		height: 44px;
		line-height: 44px;
		background: #1275ff;
		border-radius: 20px;
	}
	.h40 {
		height: 40px;
	}
	.box3 {
		.wait {
			text-decoration: underline;
			color: #1275ff;
			cursor: pointer;
		}
	}
</style>
